// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card___msRh","description":"styles_description__HUGgb","wrapper":"styles_wrapper__2iN4v","logo":"styles_logo__Uulb_"};